import router from '@/router'
import SearchModel from '../model/SearchModel'
import cmd from '@/common/Command'

const WordModule = {
  namespaced: true,
  state: {
    targetModel: null,
    data: [],
    rows: [],
    keyword: "",
    content: "",
    col1Flag: true,
    col2Flag: true,
    col3Flag: true,
    col4Flag: true,
    col5Flag: true,
    col6Flag: true,
    col7Flag: true,
    col8Flag: true,
    col9Flag: true,
    col10Flag: true,
    col11Flag: true,
    scrollPos: 0
  },
  mutations: {
    setData (state, value) {
      state.data = value
    },
    setRows (state, value) {
      state.rows = value
    },
    setVisible (state, value) {
      state.visibleFlag = value
    },
    setKeyword (state, value) {
      state.keyword = value
    },
    setContent (state, value) {
      state.content = value
    },
    initData(state, value) {
      //リセット
      if (state.targetModel != null) {
        state.targetModel.keyword = ""
      }
      state.rows = state.data
      state.scrollPos = 0
    },
    setCol1Flag (state, value) {
      state.col1Flag = value
    },
    setCol2Flag (state, value) {
      state.col2Flag = value
    },
    setCol3Flag (state, value) {
      state.col3Flag = value
    },
    setCol4Flag (state, value) {
      state.col4Flag = value
    },
    setCol5Flag (state, value) {
      state.col5Flag = value
    },
    setCol6Flag (state, value) {
      state.col6Flag = value
    },
    setCol7Flag (state, value) {
      state.col7Flag = value
    },
    setCol8Flag (state, value) {
      state.col8Flag = value
    },
    setCol9Flag (state, value) {
      state.col9Flag = value
    },
    setCol10Flag (state, value) {
      state.col10Flag = value
    },
    setCol11Flag (state, value) {
      state.col11Flag = value
    },

  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //データ取得
    loadData ({ commit, state, rootState }) {

      //スクロール位置を復元
      $('html').scrollTop(state.scrollPos)

      if (state.data.length != 0) {
        return
      }

      var currentHeader = ""
      function callback(rows){
        var list = []
        $.each(rows, function(idx, row){
          if (row != "") {

            //
            var ret = cmd.getHeaderLetter(row[1])
            var headerLetter = ""
            if (currentHeader != ret) {
              currentHeader = ret
              headerLetter = ret
            } else {
              headerLetter = "&emsp;"
            }

            //改行削除
            var filter_value = row[3].replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')

            list.push({"id": row[0], "column" : row[1], "yomi": row[2], "value": row[3], "filter_value": filter_value, "content": row[4], "header": headerLetter, "part": row[5], "part_order": row[6]})
          }
        })
        commit('setData', list)

        //初期表示データ
        commit('setRows', list)

        //行ボタンの可否
        commit("setCol1Flag", cmd.hasColumnData(state.data, "あ"))
        commit("setCol2Flag", cmd.hasColumnData(state.data, "か"))
        commit("setCol3Flag", cmd.hasColumnData(state.data, "さ"))
        commit("setCol4Flag", cmd.hasColumnData(state.data, "た"))
        commit("setCol5Flag", cmd.hasColumnData(state.data, "な"))
        commit("setCol6Flag", cmd.hasColumnData(state.data, "は"))
        commit("setCol7Flag", cmd.hasColumnData(state.data, "ま"))
        commit("setCol8Flag", cmd.hasColumnData(state.data, "や"))
        commit("setCol9Flag", cmd.hasColumnData(state.data, "ら"))
        commit("setCol10Flag", cmd.hasColumnData(state.data, "わ"))
        commit("setCol11Flag", cmd.hasColumnData(state.data, "A"))

      }
      cmd.getData("word", callback)

    },
    //行検索
    searchColumn ({ commit, state, rootState }, column) {

      state.targetModel.keyword = ""

      if (column == "") {
        $('html').scrollTop(0)
        commit('setRows', state.data)
        return
      }

      var tgt = cmd.getHeaderLetter(column)
      var ret = [];
      $.each(state.data, function(idx, row){
        if (cmd.getHeaderLetter(row.column) == tgt){

          //先頭行だけヘッダー文字セット
          if (ret.length == 0) {
            row.header = tgt
          } else {
            row.header = "&emsp;"
          }
          ret.push(row)
        }
      })

      //commit('setVisible', true)
      $('html').scrollTop(0)
      commit('setRows', ret)

    },
    searchPart ({ commit, state, rootState }, part) {

      state.targetModel.keyword = ""

      if (part == "") {
        $('html').scrollTop(0)
        commit('setRows', state.data)
        return
      }

      var ret = [];
      $.each(state.data, function(idx, row){
        if (row.part == part){
          ret.push(row)
        }
      })

      //commit('setVisible', true)
      $('html').scrollTop(0)
      commit('setRows', ret)

    },
    //検索
    search ({ commit, state, rootState }, keyword) {
      //var tgt = state.targetModel
      //var keyword = String(tgt.keyword)
      if (keyword == "") {
        //commit('setVisible', false)
        commit('setRows', state.data)
        return
      }

      function hankaku2Zenkaku(str) {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
      }
      function hankana2Zenkana(str) {
        var kanaMap = {
            'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
            'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
            'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
            'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
            'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
            'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
            'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
            'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
            'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
            'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
            'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
            'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
            'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
            'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
            'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
            'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
            'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
            'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
            '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
        };

        var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
        return str
                .replace(reg, function (match) {
                    return kanaMap[match];
                })
                .replace(/ﾞ/g, '゛')
                .replace(/ﾟ/g, '゜');
      };
      function kanaToHira(str) {
        return str.replace(/[\u30a1-\u30f6]/g, function(match) {
            var chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
      }
      function manualLowercase(s) {
        return s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);});
      };

      function convertWord(value) {
        //小文字にする
        value = value.toLowerCase()
        //半角英数字にする
        value = hankaku2Zenkaku(value)
        //半角カタカナを全角カタカナにする
        value = hankana2Zenkana(value)
        //全角カタカナをひらがなにする
        value = kanaToHira(value)
        return value
      }

      //文字を変換
      keyword = convertWord(keyword);

      var ret = [];
      $.each(state.data, function(idx, row){

        //文字を変換（読み、用語）
        var yomi = convertWord(row.yomi);
        var value = convertWord(row.value);
        if (yomi.indexOf(keyword) != -1 || value.indexOf(keyword) != -1){
          ret.push(row)
        }
      });

      //commit('setVisible', true)
      commit('setRows', ret)

    },
    //次ページ
    showDetail ({ commit, state, rootState }, keyword) {

      //スクロール位置を退避
      state.scrollPos = $('html').scrollTop()

      commit('setKeyword', keyword)

      //対象コンテンツを取得
      var content = ""
      $.each(state.rows, function(idx, row){
          if (row.value == keyword) {
            content = row.content
            return false
          }
      })
      commit('setContent', content)

      router.push('wordDetail')
    }
  },
  getters: {
    model (state, getters, rootState) {

      if (state.targetModel == null) {
        var model = new SearchModel()
        state.targetModel = model
      }

      return state.targetModel
    },
    rows (state, getters, rootState) {
      return state.rows
    },
    title (state, getters, rootState) {
      return state.keyword
    },
    content (state, getters, rootState) {
      return state.content
    },
    hasCol1 (state, getters, rootState) {
      return state.col1Flag
    },
    hasCol2 (state, getters, rootState) {
      return state.col2Flag
    },
    hasCol3 (state, getters, rootState) {
      return state.col3Flag
    },
    hasCol4 (state, getters, rootState) {
      return state.col4Flag
    },
    hasCol5 (state, getters, rootState) {
      return state.col5Flag
    },
    hasCol6 (state, getters, rootState) {
      return state.col6Flag
    },
    hasCol7 (state, getters, rootState) {
      return state.col7Flag
    },
    hasCol8 (state, getters, rootState) {
      return state.col8Flag
    },
    hasCol9 (state, getters, rootState) {
      return state.col9Flag
    },
    hasCol10 (state, getters, rootState) {
      return state.col10Flag
    },
    hasCol11 (state, getters, rootState) {
      return state.col11Flag
    },

  }
}

export default WordModule



// WEBPACK FOOTER //
// ./src/store/modules/WordModule.js